import './App.css';
import GlobeComponent from './GlobeComponent';

function App() {
  return (
    <div className="App">
      <GlobeComponent />
    </div>
  );
}

export default App;
